import { QuestionMarkIcon } from '@radix-ui/react-icons';
import { Text } from '@radix-ui/themes';
import { StringHelper } from 'classes/helpers/string.helper';
import { CustomIconPath } from 'enums/custom.enums';
import { RadixColor } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';

const getContent = (icon: CustomIconPath) => {
  switch (icon) {
    case CustomIconPath.Void: {
      return (
        <svg
          width="0"
          height="16"
          viewBox="0 0 0 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* literally nothing */}
        </svg>
      );
    }

    case CustomIconPath.CollapseAll: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.60001 7.46646C1.30546 7.46646 1.06668 7.70524 1.06668 7.99979C1.06668 8.29434 1.30546 8.53312 1.60001 8.53312L14.4 8.53312C14.6945 8.53312 14.9333 8.29434 14.9333 7.99979C14.9333 7.70524 14.6945 7.46646 14.4 7.46646L1.60001 7.46646ZM9.79373 12.6058C9.98118 12.7933 10.2851 12.7933 10.4725 12.6058C10.66 12.4184 10.66 12.1144 10.4725 11.927L8.33921 9.79366C8.15177 9.60621 7.84784 9.60621 7.6604 9.79366L5.52706 11.927C5.33961 12.1144 5.33961 12.4184 5.52706 12.6058C5.71451 12.7933 6.01844 12.7933 6.20588 12.6058L7.51981 11.2919L7.51981 14.9333C7.51981 15.1984 8.2649 15.4133 7.9998 15.4133C7.73471 15.4133 8.47981 15.1984 8.47981 14.9333L8.47981 11.2919L9.79373 12.6058ZM10.4725 4.07243C10.66 3.88502 10.66 3.58112 10.4725 3.3936C10.2851 3.20619 9.98118 3.20619 9.79373 3.3936L8.47981 4.70752L8.47981 1.06664C8.47981 0.80154 8.2649 0.586639 7.99981 0.586639C7.73471 0.586639 7.51981 0.80154 7.51981 1.06664L7.51981 4.70752L6.20588 3.3936C6.01843 3.20619 5.71451 3.20619 5.52706 3.3936C5.33961 3.58112 5.33961 3.88502 5.52706 4.07243L7.6604 6.20576C7.84784 6.39328 8.15177 6.39328 8.33921 6.20576L10.4725 4.07243Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.LowerMachine: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.49768H12.5C13.0523 2.49768 13.5 2.9454 13.5 3.49768V6.5C13.5 6.77614 13.7239 7 14 7C14.2761 7 14.5 6.77614 14.5 6.5V3.49768C14.5 2.39311 13.6046 1.49768 12.5 1.49768H11.7532C11.3495 1.49768 11.0008 1.81966 11 2.24319L5 2.24514C4.99905 1.82178 4.65039 1.49996 4.24684 1.49996L3.49998 1.49997C2.39542 1.49998 1.5 2.39541 1.5 3.49997V12.5L0.999981 12.5C0.723839 12.5 0.499989 12.7239 0.5 13C0.500011 13.2762 0.723877 13.5 1.00002 13.5L6 13.5C6.27614 13.5 6.5 13.2761 6.5 13C6.5 12.7238 6.27614 12.5 6 12.5H5V3.24514L11 3.24319V3.5C11 3.77614 11.2239 4 11.5 4C11.7761 4 12 3.77614 12 3.5V2.49768ZM4 12.5V2.49996L3.49999 2.49997C2.94771 2.49997 2.5 2.94769 2.5 3.49997V12.5H4ZM11.5 6.5C11.7761 6.5 12 6.72386 12 7V12.8866L14.6678 10.5152C14.8742 10.3317 15.1902 10.3503 15.3737 10.5567C15.5572 10.7631 15.5386 11.0791 15.3322 11.2626L11.8322 14.3737C11.6427 14.5421 11.3573 14.5421 11.1678 14.3737L7.66782 11.2626C7.46143 11.0791 7.44284 10.7631 7.6263 10.5567C7.80975 10.3503 8.12579 10.3317 8.33218 10.5152L11 12.8866V7C11 6.72386 11.2239 6.5 11.5 6.5Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.ResetMachine: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.2 1.06665C2.02179 1.06665 1.06667 2.02178 1.06667 3.19998V12.8H0.533333C0.238781 12.8 0 13.0388 0 13.3333C0 13.6279 0.238781 13.8667 0.533333 13.8667H5.86667C6.16122 13.8667 6.4 13.6279 6.4 13.3333C6.4 13.0388 6.16122 12.8 5.86667 12.8H4.8V3.19998L11.2 3.19998V4.19998C11.2 4.49454 11.4388 4.73332 11.7333 4.73332C12.0279 4.73332 12.2667 4.49454 12.2667 4.19998V2.13332H12.8C13.3891 2.13332 13.8667 2.61088 13.8667 3.19998V5.33332C13.8667 5.62787 14.1054 5.86665 14.4 5.86665C14.6946 5.86665 14.9333 5.62787 14.9333 5.33332V3.19998C14.9333 2.02178 13.9782 1.06665 12.8 1.06665H11.7333C11.4388 1.06665 11.2 1.30543 11.2 1.59998V2.13332H4.8V1.59998C4.8 1.30543 4.56122 1.06665 4.26667 1.06665H3.2ZM3.73333 12.8H2.13333V3.19998C2.13333 2.61088 2.6109 2.13332 3.2 2.13332H3.73333V12.8Z"
            fill="currentColor"
          />
          <path
            d="M8.53333 10.6666C8.53333 8.90983 9.99086 7.46665 11.8125 7.46665C13.169 7.46665 13.8928 8.24604 14.3229 8.98454L13.6976 8.98445C13.4031 8.98441 13.1643 9.22316 13.1642 9.51771C13.1642 9.81226 13.4029 10.0511 13.6975 10.0511H15.4671C15.7615 10.0509 16 9.81219 16 9.51779L16 7.46665C16 7.1721 15.7612 6.93332 15.4667 6.93332C15.1721 6.93332 14.9333 7.1721 14.9333 7.46665V7.97427C14.347 7.18287 13.389 6.39998 11.8125 6.39998C9.42296 6.39998 7.46667 8.29974 7.46667 10.6666C7.46667 13.0336 9.42296 14.9333 11.8125 14.9333C13.6599 14.9333 15.244 13.8003 15.8714 12.194C15.9786 11.9197 15.843 11.6104 15.5687 11.5032C15.2943 11.396 14.985 11.5316 14.8779 11.8059C14.409 13.0065 13.2168 13.8667 11.8125 13.8667C9.99086 13.8667 8.53333 12.4235 8.53333 10.6666Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.ConnectedMachine: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.2 0.800049C2.02179 0.800049 1.06667 1.75517 1.06667 2.93338V12.5334H0.533333C0.238781 12.5334 0 12.7722 0 13.0667C0 13.3613 0.238781 13.6 0.533333 13.6H5.33328C5.62783 13.6 5.86661 13.3613 5.86661 13.0667C5.86661 12.7722 5.62783 12.5334 5.33328 12.5334H4.8V2.93338H11.2V4.00836C11.2 4.30291 11.4388 4.5417 11.7333 4.5417C12.0279 4.5417 12.2667 4.30291 12.2667 4.00836V1.86672H12.8C13.3891 1.86672 13.8667 2.34428 13.8667 2.93338V5.06672C13.8667 5.36127 14.1054 5.60005 14.4 5.60005C14.6946 5.60005 14.9333 5.36127 14.9333 5.06672V2.93338C14.9333 1.75517 13.9782 0.800049 12.8 0.800049H11.7333C11.4388 0.800049 11.2 1.03883 11.2 1.33338V1.86672H4.8V1.33338C4.8 1.03883 4.56122 0.800049 4.26667 0.800049H3.2ZM3.73333 12.5334H2.13333V2.93338C2.13333 2.34428 2.6109 1.86672 3.2 1.86672H3.73333V12.5334Z"
            fill="currentColor"
          />
          <path
            d="M10.4467 12.5927C10.5574 12.7064 10.7129 12.765 10.8711 12.7525C11.0293 12.7399 11.1737 12.6576 11.2651 12.5279L13.1846 9.80208C13.3542 9.56125 13.2964 9.22854 13.0556 9.05895C12.8148 8.88935 12.4821 8.9471 12.3125 9.18793L10.7631 11.3882L10.3944 11.0092C10.189 10.7981 9.85139 10.7935 9.64026 10.9989C9.42913 11.2042 9.42448 11.5419 9.62988 11.753L10.4467 12.5927Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 10.6651C16 13.1697 13.9696 15.2 11.465 15.2C8.96045 15.2 6.93008 13.1697 6.93008 10.6651C6.93008 8.1605 8.96045 6.13013 11.465 6.13013C13.9696 6.13013 16 8.1605 16 10.6651ZM14.9333 10.6651C14.9333 12.5806 13.3805 14.1334 11.465 14.1334C9.54955 14.1334 7.99675 12.5806 7.99675 10.6651C7.99675 8.7496 9.54955 7.19679 11.465 7.19679C13.3805 7.19679 14.9333 8.7496 14.9333 10.6651Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.Machine: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.06667 13.3333V8.01723C1.06648 8.0115 1.06639 8.00575 1.06639 7.99998V3.73331C1.06639 2.5551 2.02152 1.59998 3.19973 1.59998H4.26639C4.56094 1.59998 4.8 1.83876 4.8 2.13331V2.66664H11.1997V2.13331C11.1997 1.83876 11.4385 1.59998 11.7331 1.59998H12.7997C13.9779 1.59998 14.9333 2.5551 14.9333 3.73331V7.99998C14.9333 8.00575 14.9332 8.0115 14.9331 8.01723V13.3333H15.4664C15.7609 13.3333 15.9997 13.5721 15.9997 13.8666C15.9997 14.1612 15.7609 14.4 15.4664 14.4H0.533333C0.238781 14.4 0 14.1612 0 13.8666C0 13.5721 0.238781 13.3333 0.533333 13.3333H1.06667ZM11.1997 13.3333V3.73331H4.8V13.3333H11.1997ZM3.73306 2.66664V4.79998C3.73306 4.80575 3.73315 4.81151 3.73333 4.81724V13.3333H2.13333V3.73331C2.13333 3.14421 2.6109 2.66664 3.2 2.66664H3.73306ZM12.2664 4.81726V13.3333H13.8664V3.73331C13.8664 3.14421 13.3888 2.66664 12.7997 2.66664H12.2667V4.79998C12.2667 4.80576 12.2666 4.81152 12.2664 4.81726Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.DisconnectedMachine: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.2 0.800049C2.02179 0.800049 1.06667 1.75517 1.06667 2.93338V12.5334H0.533333C0.238781 12.5334 0 12.7722 0 13.0667C0 13.3613 0.238781 13.6 0.533333 13.6H5.33105C5.6256 13.6 5.86438 13.3613 5.86438 13.0667C5.86438 12.7722 5.6256 12.5334 5.33105 12.5334H4.8V2.93338H11.2V4.00005C11.2 4.2946 11.4388 4.53338 11.7333 4.53338C12.0279 4.53338 12.2667 4.2946 12.2667 4.00005V1.86672H12.8C13.3891 1.86672 13.8667 2.34428 13.8667 2.93338V5.06672C13.8667 5.36127 14.1054 5.60005 14.4 5.60005C14.6946 5.60005 14.9333 5.36127 14.9333 5.06672V2.93338C14.9333 1.75517 13.9782 0.800049 12.8 0.800049H11.7333C11.4388 0.800049 11.2 1.03883 11.2 1.33338V1.86672H4.8V1.33338C4.8 1.03883 4.56122 0.800049 4.26667 0.800049H3.2ZM3.73333 12.5334H2.13333V2.93338C2.13333 2.34428 2.6109 1.86672 3.2 1.86672H3.73333V12.5334Z"
            fill="currentColor"
          />
          <path
            d="M10.5511 8.90835C10.3498 8.69331 10.0123 8.68217 9.79726 8.88346C9.58222 9.08475 9.57107 9.42225 9.77236 9.63729L10.7351 10.6658L9.77236 11.6943C9.57107 11.9094 9.58222 12.2469 9.79726 12.4481C10.0123 12.6494 10.3498 12.6383 10.5511 12.4233L11.4657 11.4462L12.3802 12.4233C12.5815 12.6383 12.919 12.6494 13.1341 12.4481C13.3491 12.2469 13.3602 11.9094 13.159 11.6943L12.1962 10.6658L13.159 9.63729C13.3602 9.42225 13.3491 9.08475 13.1341 8.88346C12.919 8.68217 12.5815 8.69331 12.3802 8.90835L11.4657 9.88538L10.5511 8.90835Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 10.6657C16 13.17 13.9699 15.2 11.4657 15.2C8.96146 15.2 6.93138 13.17 6.93138 10.6657C6.93138 8.16151 8.96146 6.13143 11.4657 6.13143C13.9699 6.13143 16 8.16151 16 10.6657ZM14.9333 10.6657C14.9333 12.5809 13.3808 14.1334 11.4657 14.1334C9.55056 14.1334 7.99805 12.5809 7.99805 10.6657C7.99805 8.75061 9.55056 7.1981 11.4657 7.1981C13.3808 7.1981 14.9333 8.75061 14.9333 10.6657Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.BusyMachine: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.06667 2.93338C1.06667 1.75517 2.02179 0.800049 3.2 0.800049H4.26667C4.56122 0.800049 4.8 1.03883 4.8 1.33338V1.86672H11.2V1.33338C11.2 1.03883 11.4388 0.800049 11.7333 0.800049H12.8C13.9782 0.800049 14.9333 1.75517 14.9333 2.93338V5.06672C14.9333 5.36127 14.6946 5.60005 14.4 5.60005C14.1054 5.60005 13.8667 5.36127 13.8667 5.06672V2.93338C13.8667 2.34428 13.3891 1.86672 12.8 1.86672H12.2667V4.00005C12.2667 4.2946 12.0279 4.53338 11.7333 4.53338C11.4388 4.53338 11.2 4.2946 11.2 4.00005V2.93338H4.8V12.5334H5.33333C5.62789 12.5334 5.86667 12.7722 5.86667 13.0667C5.86667 13.3613 5.62789 13.6 5.33333 13.6H0.533333C0.238781 13.6 0 13.3613 0 13.0667C0 12.7722 0.238781 12.5334 0.533333 12.5334H1.06667V2.93338ZM2.13333 12.5334H3.73333V1.86672H3.2C2.6109 1.86672 2.13333 2.34428 2.13333 2.93338V12.5334Z"
            fill="currentColor"
          />
          <path
            d="M9.60814 11.1989C9.90179 11.1989 10.1398 10.9608 10.1398 10.6672C10.1398 10.3735 9.90179 10.1355 9.60814 10.1355C9.31448 10.1355 9.07643 10.3735 9.07643 10.6672C9.07643 10.9608 9.31448 11.1989 9.60814 11.1989Z"
            fill="currentColor"
          />
          <path
            d="M11.9988 10.6672C11.9988 10.9608 11.7608 11.1989 11.4671 11.1989C11.1735 11.1989 10.9354 10.9608 10.9354 10.6672C10.9354 10.3735 11.1735 10.1355 11.4671 10.1355C11.7608 10.1355 11.9988 10.3735 11.9988 10.6672Z"
            fill="currentColor"
          />
          <path
            d="M13.3262 11.1989C13.6199 11.1989 13.8579 10.9608 13.8579 10.6672C13.8579 10.3735 13.6199 10.1355 13.3262 10.1355C13.0326 10.1355 12.7945 10.3735 12.7945 10.6672C12.7945 10.9608 13.0326 11.1989 13.3262 11.1989Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4672 15.2C13.9706 15.2 16 13.1706 16 10.6672C16 8.16383 13.9706 6.13442 11.4672 6.13442C8.96378 6.13442 6.93438 8.16383 6.93438 10.6672C6.93438 13.1706 8.96378 15.2 11.4672 15.2ZM11.4672 14.1334C13.3815 14.1334 14.9333 12.5815 14.9333 10.6672C14.9333 8.75294 13.3815 7.20109 11.4672 7.20109C9.55289 7.20109 8.00104 8.75294 8.00104 10.6672C8.00104 12.5815 9.55289 14.1334 11.4672 14.1334Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.CheckCircledFilled: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.9999 0.935486C4.09837 0.935486 0.935547 4.09831 0.935547 7.99984C0.935547 11.9013 4.09837 15.0642 7.9999 15.0642C11.9014 15.0642 15.0642 11.9013 15.0642 7.99984C15.0642 4.09831 11.9014 0.935486 7.9999 0.935486ZM10.8362 5.90689C11.0057 5.66601 10.9478 5.33332 10.707 5.1638C10.4661 4.99429 10.1334 5.05215 9.96386 5.29304L6.95442 9.56961L5.71393 8.30617C5.50756 8.09599 5.16989 8.09289 4.95971 8.29926C4.74953 8.50561 4.74643 8.84329 4.9528 9.05346L6.64169 10.7736C6.75258 10.8866 6.90792 10.9444 7.06568 10.9315C7.22343 10.9187 7.36732 10.8363 7.45841 10.7069L10.8362 5.90689Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.ArrowAxis: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.63381 10.5C4.90582 11.745 2.51599 12.0013 1.93787 11C1.24751 9.80426 3.402 7.26793 6.75004 5.33493C10.0981 3.40193 13.3719 2.80426 14.0622 3.99999C14.6459 5.01098 13.1959 6.98031 10.7104 8.73304M10.7104 8.73304L10.7104 6.60608M10.7104 8.73304L12.7899 9.10533"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </svg>
      );
    }

    case CustomIconPath.RepeatOne: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.57699 1.97735C3.78528 1.76907 3.78528 1.43138 3.57699 1.22311C3.36871 1.01482 3.03103 1.01482 2.82275 1.22311L0.689414 3.35644C0.481133 3.56472 0.481133 3.9024 0.689414 4.11068L2.82275 6.24401C3.03103 6.4523 3.36871 6.4523 3.57699 6.24401C3.78528 6.03574 3.78528 5.69805 3.57699 5.48977L2.35412 4.26689H10.1332C12.1951 4.26689 13.8665 5.93836 13.8665 8.00023C13.8665 8.29478 14.1054 8.53356 14.3999 8.53356C14.6944 8.53356 14.9332 8.29478 14.9332 8.00023C14.9332 5.34926 12.7842 3.20023 10.1332 3.20023H2.35412L3.57699 1.97735ZM2.1332 8.00023C2.1332 7.70568 1.89442 7.46689 1.59987 7.46689C1.30532 7.46689 1.06654 7.70568 1.06654 8.00023C1.06654 10.6512 3.21557 12.8002 5.86654 12.8002H13.6456L12.4227 14.0231C12.2145 14.2314 12.2145 14.5691 12.4227 14.7774C12.631 14.9856 12.9687 14.9856 13.177 14.7774L15.3104 12.6441C15.5186 12.4357 15.5186 12.098 15.3104 11.8897L13.177 9.75644C12.9687 9.54815 12.631 9.54815 12.4227 9.75644C12.2145 9.96472 12.2145 10.3024 12.4227 10.5107L13.6456 11.7336H5.86654C3.80467 11.7336 2.1332 10.0621 2.1332 8.00023Z"
            fill="currentColor"
          />
          <path
            d="M8.00253 10.8186V6.0842H7.94003L6.52206 7.09591V6.23654L8.00643 5.18185H8.88143V10.8186H8.00253Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.SwitchOn: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2 4.26666C9.13813 4.26666 7.46667 5.93813 7.46667 8C7.46667 10.0619 9.13813 11.7333 11.2 11.7333C13.2619 11.7333 14.9333 10.0619 14.9333 8C14.9333 5.93813 13.2619 4.26666 11.2 4.26666ZM0 8C0 5.34903 2.14903 3.2 4.8 3.2L11.2 3.2C13.851 3.2 16 5.34903 16 8C16 10.651 13.851 12.8 11.2 12.8L4.8 12.8C2.14903 12.8 0 10.651 0 8Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.SwitchOff: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.8 11.7333C6.86187 11.7333 8.53333 10.0619 8.53333 7.99999C8.53333 5.93813 6.86187 4.26666 4.8 4.26666C2.73813 4.26666 1.06667 5.93813 1.06667 7.99999C1.06667 10.0619 2.73813 11.7333 4.8 11.7333ZM7.81725 4.26666C8.90471 5.14666 9.6 6.49212 9.6 7.99999C9.6 9.50787 8.90471 10.8533 7.81725 11.7333L11.2 11.7333C13.2619 11.7333 14.9333 10.0619 14.9333 8C14.9333 5.93813 13.2619 4.26666 11.2 4.26666L7.81725 4.26666ZM16 8C16 10.651 13.851 12.8 11.2 12.8L4.8 12.8C2.14901 12.8 1.87875e-07 10.651 4.19629e-07 7.99999C6.51384e-07 5.34903 2.14901 3.19999 4.8 3.19999L11.2 3.19999C13.851 3.19999 16 5.34903 16 8Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.Beta: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 3.16663C0 2.06206 0.895431 1.16663 2 1.16663H14C15.1046 1.16663 16 2.06206 16 3.16663V12.8333C16 13.9379 15.1046 14.8333 14 14.8333H2C0.895431 14.8333 0 13.9379 0 12.8333V3.16663Z"
            fill="currentColor"
            fillOpacity="0.2"
          />
          <path
            d="M6.02202 10.5V4.68182H8.1527C8.56558 4.68182 8.90743 4.75 9.17827 4.88636C9.4491 5.02083 9.65175 5.2036 9.78622 5.43466C9.92069 5.66383 9.98793 5.92235 9.98793 6.21023C9.98793 6.45265 9.94342 6.6572 9.8544 6.82386C9.76539 6.98864 9.64607 7.12121 9.49645 7.22159C9.34872 7.32008 9.18584 7.39205 9.00781 7.4375V7.49432C9.20099 7.50379 9.38944 7.56629 9.57315 7.68182C9.75876 7.79545 9.91217 7.95739 10.0334 8.16761C10.1546 8.37784 10.2152 8.63352 10.2152 8.93466C10.2152 9.23201 10.1451 9.49905 10.005 9.7358C9.86671 9.97064 9.6527 10.1572 9.36293 10.2955C9.07315 10.4318 8.70289 10.5 8.25213 10.5H6.02202ZM6.89986 9.74716H8.1669C8.58736 9.74716 8.88849 9.66572 9.07031 9.50284C9.25213 9.33996 9.34304 9.13636 9.34304 8.89205C9.34304 8.70833 9.29664 8.53977 9.20384 8.38636C9.11103 8.23295 8.97846 8.1108 8.80611 8.01989C8.63565 7.92898 8.433 7.88352 8.19815 7.88352H6.89986V9.74716ZM6.89986 7.19886H8.07599C8.27296 7.19886 8.45005 7.16098 8.60724 7.08523C8.76634 7.00947 8.89228 6.90341 8.98509 6.76705C9.07978 6.62879 9.12713 6.46591 9.12713 6.27841C9.12713 6.03788 9.04285 5.83617 8.87429 5.6733C8.70573 5.51042 8.44721 5.42898 8.09872 5.42898H6.89986V7.19886Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.BetaBeaker: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
            fill="currentColor"
            fillOpacity="0.2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.81428 3.99998C5.81428 3.77906 5.99337 3.59998 6.21428 3.59998H9.78571C10.0066 3.59998 10.1857 3.77906 10.1857 3.99998C10.1857 4.22089 10.0066 4.39998 9.78571 4.39998H9.65V6.51135C9.65 6.86833 9.76938 7.21506 9.98916 7.49638L12.053 10.1381C12.7711 11.0572 12.1162 12.4 10.9497 12.4H5.05024C3.88383 12.4 3.22892 11.0572 3.94701 10.1381L6.01084 7.49638C6.23061 7.21506 6.35 6.86833 6.35 6.51134V4.39998H6.21428C5.99337 4.39998 5.81428 4.22089 5.81428 3.99998ZM7.15 4.39998V6.51134C7.15 7.04682 6.97092 7.56692 6.64125 7.98889L5.77322 9.09998H6.02362C6.59127 9.09998 7.15284 9.21696 7.67327 9.44363C8.3672 9.74585 9.14335 9.80277 9.87394 9.605L10.4909 9.438L9.35874 7.98889C9.02907 7.56692 8.85 7.04682 8.85 6.51135V4.39998H7.15ZM11.0253 10.1221L10.083 10.3772C9.17694 10.6225 8.21439 10.5519 7.35383 10.1771C6.93417 9.99431 6.48135 9.89998 6.02362 9.89998H5.14822L4.57743 10.6306C4.26967 11.0245 4.55035 11.6 5.05024 11.6H10.9497C11.4496 11.6 11.7303 11.0245 11.4226 10.6306L11.0253 10.1221Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.SuperAdmin: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 3.16663C0 2.06206 0.895431 1.16663 2 1.16663H14C15.1046 1.16663 16 2.06206 16 3.16663V12.8333C16 13.9379 15.1046 14.8333 14 14.8333H2C0.895431 14.8333 0 13.9379 0 12.8333V3.16663Z"
            fill="currentColor"
            fillOpacity="0.2"
          />
          <path
            d="M6.4476 6.21023C6.4173 5.94129 6.2923 5.73295 6.0726 5.58523C5.85291 5.43561 5.57639 5.3608 5.24306 5.3608C5.00442 5.3608 4.79798 5.39867 4.62374 5.47443C4.4495 5.5483 4.31408 5.65057 4.21749 5.78125C4.12279 5.91004 4.07545 6.05682 4.07545 6.22159C4.07545 6.35985 4.10764 6.47917 4.17204 6.57955C4.23832 6.67992 4.3245 6.7642 4.43056 6.83239C4.53851 6.89867 4.65404 6.95455 4.77715 7C4.90026 7.04356 5.01863 7.07955 5.13226 7.10795L5.70045 7.25568C5.88605 7.30114 6.07639 7.36269 6.27147 7.44034C6.46654 7.51799 6.64742 7.62027 6.81408 7.74716C6.98075 7.87405 7.11522 8.03125 7.21749 8.21875C7.32166 8.40625 7.37374 8.63068 7.37374 8.89205C7.37374 9.22159 7.28851 9.5142 7.11806 9.76989C6.9495 10.0256 6.70423 10.2273 6.38226 10.375C6.06219 10.5227 5.67488 10.5966 5.22033 10.5966C4.78473 10.5966 4.40783 10.5275 4.08965 10.3892C3.77147 10.2509 3.52241 10.0549 3.34249 9.80114C3.16257 9.54545 3.06313 9.24242 3.0442 8.89205H3.92488C3.94192 9.10227 4.0101 9.27746 4.12942 9.41761C4.25063 9.55587 4.40499 9.65909 4.59249 9.72727C4.78188 9.79356 4.98927 9.8267 5.21465 9.8267C5.46276 9.8267 5.6834 9.78788 5.87658 9.71023C6.07166 9.63068 6.22507 9.52083 6.33681 9.38068C6.44855 9.23864 6.50442 9.07292 6.50442 8.88352C6.50442 8.71117 6.45518 8.57008 6.3567 8.46023C6.2601 8.35038 6.12848 8.25947 5.96181 8.1875C5.79704 8.11553 5.61048 8.05208 5.40215 7.99716L4.71465 7.80966C4.24874 7.68277 3.87942 7.49621 3.6067 7.25C3.33586 7.00379 3.20045 6.67803 3.20045 6.27273C3.20045 5.9375 3.29135 5.64489 3.47317 5.39489C3.65499 5.14489 3.9012 4.95076 4.21181 4.8125C4.52241 4.67235 4.87279 4.60227 5.26295 4.60227C5.65688 4.60227 6.00442 4.6714 6.30556 4.80966C6.60859 4.94792 6.84723 5.13826 7.02147 5.38068C7.19571 5.62121 7.28662 5.89773 7.2942 6.21023H6.4476ZM8.89402 10.5H7.9622L10.0559 4.68182H11.0702L13.1639 10.5H12.2321L10.5872 5.73864H10.5417L8.89402 10.5ZM9.05027 8.22159H12.073V8.96023H9.05027V8.22159Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.TeamAdmin: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 3.16663C0 2.06206 0.895431 1.16663 2 1.16663H14C15.1046 1.16663 16 2.06206 16 3.16663V12.8333C16 13.9379 15.1046 14.8333 14 14.8333H2C0.895431 14.8333 0 13.9379 0 12.8333V3.16663Z"
            fill="currentColor"
            fillOpacity="0.2"
          />
          <path
            d="M3.27644 5.4375V4.68182H7.77928V5.4375H5.96394V10.5H5.08894V5.4375H3.27644ZM8.60495 10.5H7.67313L9.76688 4.68182H10.7811L12.8748 10.5H11.943L10.2981 5.73864H10.2527L8.60495 10.5ZM8.7612 8.22159H11.7839V8.96023H8.7612V8.22159Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.R2F: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0642 7.99989C15.0642 4.09843 11.9014 0.935547 7.99987 0.935547C4.29368 0.935547 1.2274 3.90711 0.955672 7.49976H0.5C0.223858 7.49976 0 7.72362 0 7.99976C0 8.2759 0.223858 8.49976 0.5 8.49976H0.952923H1.96919H4.5C4.68939 8.49976 4.86252 8.39276 4.94721 8.22337L5.9785 6.1608L8.04481 10.7069C8.1217 10.8761 8.28606 10.9887 8.47157 10.9992C8.65709 11.0098 8.83316 10.9166 8.92876 10.7573L10.2831 8.49976H12.5C12.7761 8.49976 13 8.2759 13 7.99976C13 7.72362 12.7761 7.49976 12.5 7.49976H10C9.82436 7.49976 9.6616 7.59192 9.57124 7.74253L8.56115 9.42621L6.45519 4.79287C6.37544 4.61741 6.20195 4.50341 6.00926 4.49985C5.81657 4.49628 5.63898 4.60377 5.55279 4.77615L4.19098 7.49976H1.9724C2.24132 4.45953 4.8468 1.94888 7.99987 1.94888C11.3417 1.94888 14.0509 4.658 14.0509 7.99989C14.0509 11.3418 11.3417 14.0509 7.99987 14.0509C5.12748 14.0509 2.72254 12.0495 2.1035 9.36516H1.06733C1.70336 12.6134 4.5654 15.0642 7.99987 15.0642C11.9014 15.0642 15.0642 11.9014 15.0642 7.99989Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.Baseball: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.99999 15.2C6.57596 15.2 5.18392 14.7777 3.99988 13.9866C2.81585 13.1954 1.89301 12.071 1.34806 10.7553C0.803107 9.43971 0.660523 7.99203 0.938337 6.59536C1.21615 5.1987 1.90188 3.91578 2.90882 2.90885C3.91576 1.90191 5.19868 1.21618 6.59534 0.938363C7.992 0.660549 9.43968 0.803133 10.7553 1.34808C12.0709 1.89303 13.1954 2.81588 13.9866 3.99991C14.7777 5.18394 15.2 6.57599 15.2 8.00001C15.198 9.90895 14.4388 11.7391 13.0889 13.089C11.7391 14.4388 9.90893 15.198 7.99999 15.2ZM4.1293 3.29855C4.18607 3.36778 4.24284 3.43217 4.29684 3.50002C4.34229 3.55688 4.37611 3.62215 4.39634 3.69208C4.41658 3.76202 4.42284 3.83525 4.41477 3.90761C4.4067 3.97996 4.38446 4.05002 4.34932 4.11378C4.31418 4.17754 4.26682 4.23375 4.20995 4.27921C4.15308 4.32467 4.08782 4.35848 4.01789 4.37871C3.94795 4.39895 3.87472 4.40521 3.80236 4.39714C3.73001 4.38907 3.65995 4.36683 3.59619 4.33169C3.53243 4.29655 3.47622 4.24919 3.43076 4.19232L3.33799 4.08017C2.41301 5.17686 1.90565 6.56533 1.90565 8.00001C1.90565 9.4347 2.41301 10.8232 3.33799 11.9199L3.43076 11.8077C3.47622 11.7508 3.53243 11.7035 3.59619 11.6683C3.65995 11.6332 3.73001 11.611 3.80236 11.6029C3.87472 11.5948 3.94795 11.6011 4.01789 11.6213C4.08782 11.6416 4.15308 11.6754 4.20995 11.7208C4.26682 11.7663 4.31418 11.8225 4.34932 11.8863C4.38446 11.95 4.4067 12.0201 4.41477 12.0924C4.42284 12.1648 4.41658 12.238 4.39634 12.3079C4.37611 12.3779 4.34229 12.4431 4.29684 12.5C4.24284 12.5692 4.18607 12.6385 4.1293 12.7015C5.21882 13.6006 6.58737 14.0924 7.99999 14.0924C9.41261 14.0924 10.7812 13.6006 11.8707 12.7015C11.8139 12.6322 11.7571 12.5686 11.7031 12.5C11.6577 12.4431 11.6239 12.3779 11.6036 12.3079C11.5834 12.238 11.5771 12.1648 11.5852 12.0924C11.5933 12.0201 11.6155 11.95 11.6507 11.8863C11.6858 11.8225 11.7332 11.7663 11.79 11.7208C11.8469 11.6754 11.9122 11.6416 11.9821 11.6213C12.052 11.6011 12.1253 11.5948 12.1976 11.6029C12.27 11.611 12.34 11.6332 12.4038 11.6683C12.4675 11.7035 12.5238 11.7508 12.5692 11.8077L12.662 11.9199C13.587 10.8232 14.0943 9.4347 14.0943 8.00001C14.0943 6.56533 13.587 5.17686 12.662 4.08017L12.5692 4.19232C12.5247 4.25164 12.4686 4.3014 12.4045 4.33864C12.3403 4.37589 12.2693 4.39987 12.1957 4.40916C12.1221 4.41844 12.0474 4.41284 11.976 4.3927C11.9046 4.37255 11.838 4.33827 11.7801 4.29188C11.7222 4.24549 11.6742 4.18794 11.639 4.12265C11.6038 4.05736 11.582 3.98565 11.575 3.91179C11.568 3.83794 11.576 3.76343 11.5983 3.69269C11.6207 3.62196 11.657 3.55643 11.7052 3.50002C11.7592 3.43078 11.816 3.36502 11.8728 3.29855C10.7832 2.39943 9.41468 1.90764 8.00207 1.90764C6.58945 1.90764 5.2209 2.39943 4.13137 3.29855H4.1293ZM5.77699 6.80094C5.70819 6.39241 5.60442 5.99055 5.46684 5.59978C5.41781 5.46125 5.31576 5.34786 5.18314 5.28457C5.05051 5.22128 4.89818 5.21326 4.75964 5.26228C4.62111 5.31131 4.50772 5.41336 4.44443 5.54598C4.38114 5.67861 4.37312 5.83094 4.42214 5.96948C4.53886 6.2993 4.62666 6.63866 4.68453 6.98371C4.69593 7.05598 4.72154 7.12527 4.75988 7.18759C4.79821 7.2499 4.84852 7.30401 4.90788 7.34677C4.96725 7.38954 5.0345 7.42012 5.10575 7.43674C5.177 7.45337 5.25083 7.45571 5.32299 7.44364C5.39516 7.43157 5.46421 7.40532 5.52617 7.3664C5.58813 7.32749 5.64176 7.27669 5.68397 7.21693C5.72619 7.15717 5.75614 7.08964 5.77211 7.01824C5.78807 6.94684 5.78973 6.87298 5.77699 6.80094ZM5.77699 9.19909C5.80122 9.05422 5.76691 8.90566 5.68161 8.78609C5.59631 8.66651 5.46701 8.58572 5.32214 8.56148C5.29193 8.55657 5.26137 8.55402 5.23076 8.55386C5.09984 8.55403 4.97321 8.60057 4.87334 8.68523C4.77347 8.76989 4.70682 8.88719 4.68522 9.01632C4.62735 9.36137 4.53956 9.70073 4.42284 10.0306C4.37381 10.1691 4.38183 10.3214 4.44512 10.454C4.50842 10.5867 4.6218 10.6887 4.76034 10.7377C4.89887 10.7868 5.05121 10.7788 5.18383 10.7155C5.31645 10.6522 5.4185 10.5388 5.46753 10.4002C5.60488 10.0095 5.70841 9.6076 5.77699 9.19909ZM11.24 5.26263C11.1015 5.21363 10.9493 5.22162 10.8168 5.28485C10.6842 5.34807 10.5822 5.46136 10.5331 5.59978C10.3956 5.99055 10.2918 6.39241 10.223 6.80094C10.2102 6.87298 10.2119 6.94684 10.2279 7.01824C10.2438 7.08964 10.2738 7.15717 10.316 7.21693C10.3582 7.27669 10.4119 7.32749 10.4738 7.3664C10.5358 7.40532 10.6048 7.43157 10.677 7.44364C10.7491 7.45571 10.823 7.45337 10.8942 7.43674C10.9655 7.42012 11.0327 7.38954 11.0921 7.34677C11.1515 7.30401 11.2018 7.2499 11.2401 7.18759C11.2784 7.12527 11.304 7.05598 11.3154 6.98371C11.3733 6.63866 11.4611 6.2993 11.5778 5.96948C11.6021 5.90088 11.6126 5.82818 11.6087 5.75553C11.6049 5.68288 11.5867 5.6117 11.5554 5.54606C11.524 5.48042 11.48 5.4216 11.4259 5.37297C11.3718 5.32434 11.3086 5.28685 11.24 5.26263ZM10.223 9.19909C10.2918 9.60762 10.3956 10.0095 10.5331 10.4002C10.5822 10.5388 10.6842 10.6522 10.8168 10.7155C10.9495 10.7788 11.1018 10.7868 11.2403 10.7377C11.3789 10.6887 11.4923 10.5867 11.5555 10.454C11.6188 10.3214 11.6269 10.1691 11.5778 10.0306C11.4611 9.70073 11.3733 9.36137 11.3154 9.01632C11.2938 8.88708 11.2271 8.76968 11.1271 8.68501C11.0271 8.60034 10.9003 8.55387 10.7692 8.55386C10.7384 8.55399 10.7076 8.55653 10.6771 8.56148C10.5324 8.58588 10.4033 8.66674 10.3181 8.7863C10.233 8.90585 10.1987 9.05432 10.223 9.19909Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case CustomIconPath.Helmet: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1394 3.6C10.324 2.86339 8.88881 2.29164 6.40039 2.85124C4.96577 3.17387 3.99912 3.65423 3.34543 4.20485C2.69737 4.75073 2.32908 5.84977 2.12612 6.54009C1.92035 7.23997 1.88254 8.0009 1.91408 8.78508C1.93346 9.26713 1.97496 9.71156 2.01624 10.1536C2.03025 10.3036 2.04424 10.4534 2.05733 10.6043C2.3273 10.6323 2.60555 10.6834 2.86571 10.7631C3.27255 10.8878 3.75742 11.1198 4.00348 11.5643C4.70434 12.8305 6.27757 13.1872 7.45072 12.7148C8.01982 12.4857 8.45522 12.0741 8.64431 11.5108C8.8338 10.9463 8.80426 10.1432 8.26508 9.08462C8.17922 8.91605 8.18818 8.71569 8.28874 8.5552C8.3893 8.39471 8.56711 8.29699 8.75859 8.29699C10.3144 8.29699 11.907 8.02069 13.7606 7.20329C13.7445 7.19289 13.728 7.18247 13.7111 7.17205C13.382 6.96948 13.0266 6.84686 12.8075 6.84686C12.5025 6.84686 12.2553 6.6034 12.2553 6.30307C12.2553 5.85364 11.9897 4.36814 11.1394 3.6ZM13.3158 5.82647C13.1895 5.08336 12.7755 3.60219 11.8858 2.79849C10.7496 1.77208 8.91987 1.16907 6.15459 1.79094C4.59685 2.14125 3.45209 2.68392 2.62773 3.3783C1.79775 4.07741 1.32137 4.90623 1.06545 5.77666C0.812348 6.63753 0.777081 7.99208 0.810702 8.82812C0.830422 9.31848 0.877997 9.8365 0.921815 10.3136C0.949683 10.617 0.976031 10.9039 0.992728 11.1566C1.01162 11.4427 1.25267 11.6651 1.54368 11.6651C1.86938 11.6651 2.2356 11.7091 2.53776 11.8017C2.86408 11.9016 2.99868 12.0212 3.03396 12.0849C4.04853 13.9179 6.26551 14.367 7.86858 13.7215C8.68758 13.3917 9.3868 12.7635 9.69272 11.8522C9.93404 11.1334 9.91297 10.2922 9.58246 9.35987C11.2297 9.25946 12.9384 8.84051 14.8948 7.87705C15.0818 7.78493 15.2 7.59664 15.2 7.39066C15.2 7.21513 15.1358 7.06904 15.0784 6.97004C15.018 6.86605 14.9411 6.77289 14.8636 6.69275C14.7084 6.5322 14.5079 6.38002 14.2964 6.24978C14.0206 6.08002 13.6724 5.91516 13.3158 5.82647Z"
            fill="currentColor"
          />
          <path
            d="M7.28627 10.6534C7.28627 11.0539 6.95668 11.3785 6.55011 11.3785C6.14354 11.3785 5.81395 11.0539 5.81395 10.6534C5.81395 10.253 6.14354 9.92837 6.55011 9.92837C6.95668 9.92837 7.28627 10.253 7.28627 10.6534Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.CalibrateDevice: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.2 1.6001C2.02179 1.6001 1.06667 2.55522 1.06667 3.73343V13.3334H0.533333C0.238781 13.3334 0 13.5722 0 13.8668C0 14.1613 0.238781 14.4001 0.533333 14.4001H5.86667C6.16122 14.4001 6.4 14.1613 6.4 13.8668C6.4 13.5722 6.16122 13.3334 5.86667 13.3334H4.8V3.73343H11.2C11.2 4.02798 11.4388 4.26676 11.7333 4.26676C12.0279 4.26676 12.2667 4.02798 12.2667 3.73343V2.66676H12.8C13.3891 2.66676 13.8667 3.14433 13.8667 3.73343V5.86676C13.8667 6.16132 14.1054 6.4001 14.4 6.4001C14.6946 6.4001 14.9333 6.16132 14.9333 5.86676V3.73343C14.9333 2.55522 13.9782 1.6001 12.8 1.6001H11.7333C11.4388 1.6001 11.2 1.83888 11.2 2.13343V2.66676H4.8V2.13343C4.8 1.83888 4.56122 1.6001 4.26667 1.6001H3.2ZM3.73333 13.3334H2.13333V3.73343C2.13333 3.14433 2.6109 2.66676 3.2 2.66676H3.73333V13.3334Z"
            fill="currentColor"
          />
          <path
            d="M8.53333 11.2001C8.53333 9.44328 9.99086 8.0001 11.8125 8.0001C13.169 8.0001 13.8928 8.77949 14.3229 9.51799L13.6976 9.5179C13.4031 9.51786 13.1643 9.75661 13.1642 10.0512C13.1642 10.3457 13.4029 10.5845 13.6975 10.5846H15.4671C15.7615 10.5844 16 10.3456 16 10.0512L16 8.0001C16 7.70555 15.7612 7.46676 15.4667 7.46676C15.1721 7.46676 14.9333 7.70555 14.9333 8.0001V8.50772C14.347 7.71632 13.389 6.93343 11.8125 6.93343C9.42296 6.93343 7.46667 8.83319 7.46667 11.2001C7.46667 13.567 9.42296 15.4668 11.8125 15.4668C13.6599 15.4668 15.244 14.3338 15.8714 12.7275C15.9786 12.4531 15.843 12.1438 15.5687 12.0366C15.2943 11.9295 14.985 12.065 14.8779 12.3394C14.409 13.5399 13.2168 14.4001 11.8125 14.4001C9.99086 14.4001 8.53333 12.9569 8.53333 11.2001Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.FolderOpen: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.06252 3.19998C1.06251 2.90543 1.30129 2.66664 1.59585 2.66664H5.11281C5.29247 2.66664 5.46006 2.7571 5.55866 2.90729L6.32993 4.08219C6.62572 4.53277 7.12849 4.80414 7.66748 4.80414H12.5862C12.8807 4.80414 13.1195 5.04292 13.1195 5.33748V5.87106H14.1862V5.33748C14.1862 4.45382 13.4699 3.73748 12.5862 3.73748H7.66748C7.48782 3.73748 7.32023 3.64702 7.22163 3.49682L6.45036 2.32193C6.15457 1.87135 5.6518 1.59998 5.11281 1.59998H1.59585C0.712184 1.59998 -0.00416485 2.31634 -0.00415039 3.2L-0.00413287 12.8C-0.00413287 13.6836 0.712211 14.4 1.59587 14.4H12.5862V13.3333H1.59587C1.30132 13.3333 1.06253 13.0945 1.06253 12.8L1.06252 3.19998Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.63779 6.93133C3.40428 6.93133 3.19793 7.08323 3.12855 7.3062L1.46894 12.6397C1.36212 12.983 1.61865 13.3315 1.97819 13.3315H12.7349C12.9684 13.3315 13.1747 13.1796 13.2441 12.9566L14.9037 7.62312C15.0105 7.27982 14.754 6.93133 14.3945 6.93133H3.63779ZM2.11005 6.98928C2.31819 6.32038 2.93726 5.86466 3.63779 5.86466H14.3945C15.4731 5.86466 16.2427 6.91014 15.9222 7.94004L14.2626 13.2735C14.0545 13.9424 13.4354 14.3982 12.7349 14.3982H1.97819C0.899582 14.3982 0.129972 13.3527 0.450443 12.3228L2.11005 6.98928Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.FolderClosed: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.59585 2.66667C1.30129 2.66667 1.06251 2.90546 1.06252 3.20001L1.06254 12.8C1.06254 13.0946 1.30132 13.3333 1.59587 13.3333H14.3958C14.6904 13.3333 14.9292 13.0946 14.9292 12.8V5.86516C14.9292 5.57061 14.6904 5.33182 14.3958 5.33182H8.60106C8.03866 5.33182 7.51756 5.03655 7.22853 4.5541L6.25309 2.92591C6.15675 2.7651 5.98305 2.66667 5.79558 2.66667H1.59585ZM-0.00415039 3.20003C-0.00416358 2.31636 0.712185 1.60001 1.59585 1.60001H5.79558C6.35798 1.60001 6.87908 1.89528 7.16812 2.37773L8.14355 4.00592C8.23989 4.16673 8.4136 4.26516 8.60106 4.26516H14.3958C15.2795 4.26516 15.9958 4.9815 15.9958 5.86516V12.8C15.9958 13.6837 15.2795 14.4 14.3958 14.4H1.59587C0.712217 14.4 -0.00412652 13.6837 -0.00412652 12.8L-0.00415039 3.20003Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.59583 5.33699C1.30128 5.33699 1.0625 5.57577 1.0625 5.87032V12.7971C1.0625 13.0916 1.30128 13.3304 1.59583 13.3304H14.3958C14.6904 13.3304 14.9292 13.0916 14.9292 12.7971V5.87032C14.9292 5.57577 14.6904 5.33699 14.3958 5.33699H1.59583ZM-0.00416756 5.87032C-0.00416756 4.98667 0.712177 4.27032 1.59583 4.27032H14.3958C15.2795 4.27032 15.9958 4.98667 15.9958 5.87032V12.7971C15.9958 13.6807 15.2795 14.3971 14.3958 14.3971H1.59583C0.712178 14.3971 -0.00416756 13.6807 -0.00416756 12.7971V5.87032Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.AddPitch: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M3.09264 3.10216C4.3477 1.84467 6.08299 1.06667 8 1.06667C9.91742 1.06667 11.653 1.845 12.9082 3.10296C12.8795 3.13672 12.8511 3.17071 12.8231 3.20495C12.6341 3.4356 12.6679 3.77578 12.8986 3.96475C13.1132 4.1406 13.4227 4.12355 13.6169 3.93447C14.445 5.07665 14.9333 6.4813 14.9333 8C14.9333 8.29455 15.1721 8.53333 15.4667 8.53333C15.7612 8.53333 16 8.29455 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C8.29455 16 8.53333 15.7612 8.53333 15.4667C8.53333 15.1721 8.29455 14.9333 8 14.9333C6.08261 14.9333 4.34701 14.155 3.09189 12.8971C3.12054 12.8634 3.14888 12.8294 3.17692 12.7952C3.36589 12.5645 3.3321 12.2243 3.10145 12.0354C2.88683 11.8595 2.57738 11.8766 2.38316 12.0656C1.55498 10.9234 1.06667 9.51873 1.06667 8C1.06667 6.48082 1.55526 5.07577 2.38389 3.93339C2.57833 4.12283 2.88832 4.13969 3.10296 3.96332C3.33334 3.77401 3.36664 3.43379 3.17734 3.20341C3.14938 3.16939 3.12114 3.13564 3.09264 3.10216Z"
            fill="currentColor"
          />
          <path
            d="M3.71304 5.02171C3.99222 4.917 4.30344 5.05845 4.40815 5.33764C4.49416 5.56697 4.56981 5.80245 4.63444 6.04365C4.69907 6.28484 4.75129 6.5266 4.79147 6.76821C4.84038 7.06235 4.64159 7.34046 4.34745 7.38937C4.0533 7.43828 3.7752 7.23949 3.72629 6.94534C3.69183 6.73813 3.647 6.53053 3.59143 6.32312C3.53585 6.11571 3.47088 5.91351 3.39711 5.71683C3.2924 5.43764 3.43384 5.12642 3.71304 5.02171Z"
            fill="currentColor"
          />
          <path
            d="M4.3483 8.611C4.64247 8.65976 4.84142 8.93775 4.79267 9.23191C4.71126 9.72312 4.58173 10.2023 4.40789 10.663C4.30263 10.942 3.99113 11.0829 3.71215 10.9776C3.43317 10.8723 3.29235 10.5608 3.39761 10.2818C3.54669 9.88674 3.65767 9.47605 3.72739 9.05537C3.77614 8.7612 4.05413 8.56225 4.3483 8.611Z"
            fill="currentColor"
          />
          <path
            d="M12.2879 5.02252C12.5668 5.12778 12.7077 5.43928 12.6024 5.71826C12.4533 6.11336 12.3423 6.52405 12.2726 6.94474C12.2239 7.23891 11.9459 7.43785 11.6517 7.3891C11.3575 7.34035 11.1586 7.06236 11.2073 6.7682C11.2888 6.27699 11.4183 5.79778 11.5921 5.33706C11.6974 5.05808 12.0089 4.91725 12.2879 5.02252Z"
            fill="currentColor"
          />
          <path
            d="M13.3333 10.1333C13.3333 9.83878 13.0946 9.6 12.8 9.6C12.5054 9.6 12.2667 9.83878 12.2667 10.1333V12.2667H10.1333C9.83878 12.2667 9.6 12.5054 9.6 12.8C9.6 13.0946 9.83878 13.3333 10.1333 13.3333H12.2667V15.4667C12.2667 15.7612 12.5054 16 12.8 16C13.0946 16 13.3333 15.7612 13.3333 15.4667V13.3333H15.4667C15.7612 13.3333 16 13.0946 16 12.8C16 12.5054 15.7612 12.2667 15.4667 12.2667H13.3333V10.1333Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.RowsAdd: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.533203 3.19984C0.533203 2.90529 0.771985 2.6665 1.06654 2.6665H14.9332C15.2278 2.6665 15.4665 2.90529 15.4665 3.19984C15.4665 3.49439 15.2278 3.73317 14.9332 3.73317H1.06654C0.771985 3.73317 0.533203 3.49439 0.533203 3.19984ZM0.533203 6.39984C0.533203 6.10529 0.771985 5.8665 1.06654 5.8665H14.9332C15.2278 5.8665 15.4665 6.10529 15.4665 6.39984C15.4665 6.69439 15.2278 6.93317 14.9332 6.93317H1.06654C0.771985 6.93317 0.533203 6.69439 0.533203 6.39984ZM0.533203 9.59984C0.533203 9.30529 0.771985 9.0665 1.06654 9.0665H8.5332C8.82776 9.0665 9.06654 9.30529 9.06654 9.59984C9.06654 9.89439 8.82776 10.1332 8.5332 10.1332H1.06654C0.771985 10.1332 0.533203 9.89439 0.533203 9.59984ZM12.7999 9.0665C13.0944 9.0665 13.3332 9.30529 13.3332 9.59984V11.1998H14.9332C15.2278 11.1998 15.4665 11.4386 15.4665 11.7332C15.4665 12.0277 15.2278 12.2665 14.9332 12.2665H13.3332V13.8665C13.3332 14.1611 13.0944 14.3998 12.7999 14.3998C12.5053 14.3998 12.2665 14.1611 12.2665 13.8665V12.2665H10.6665C10.372 12.2665 10.1332 12.0277 10.1332 11.7332C10.1332 11.4386 10.372 11.1998 10.6665 11.1998H12.2665V9.59984C12.2665 9.30529 12.5053 9.0665 12.7999 9.0665ZM0.533203 12.7998C0.533203 12.5053 0.771985 12.2665 1.06654 12.2665H7.46654C7.76109 12.2665 7.99987 12.5053 7.99987 12.7998C7.99987 13.0944 7.76109 13.3332 7.46654 13.3332H1.06654C0.771985 13.3332 0.533203 13.0944 0.533203 12.7998Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.AddAverages: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.80376 3.58432C4.26188 1.75184 5.90836 0.466309 7.79724 0.466309C9.63512 0.466309 11.2503 1.68466 11.7552 3.45183L12.4414 5.85325C12.5223 6.13655 12.3583 6.43184 12.0749 6.51278C11.7916 6.59373 11.4964 6.42968 11.4154 6.14637L10.7293 3.74496C10.3553 2.43586 9.15873 1.53331 7.79724 1.53331C6.39798 1.53331 5.17827 2.48562 4.8389 3.8431L4.26738 6.1292C4.19592 6.41505 3.90626 6.58884 3.62042 6.51738C3.33457 6.44592 3.16078 6.15626 3.23224 5.87042L3.80376 3.58432ZM0.466309 7.99981C0.466309 7.70516 0.705165 7.46631 0.999809 7.46631H2.99981C3.29445 7.46631 3.53331 7.70516 3.53331 7.99981C3.53331 8.29445 3.29445 8.53331 2.99981 8.53331H0.999809C0.705165 8.53331 0.466309 8.29445 0.466309 7.99981ZM4.46631 7.99981C4.46631 7.70516 4.70516 7.46631 4.99981 7.46631H6.99981C7.29445 7.46631 7.53331 7.70516 7.53331 7.99981C7.53331 8.29445 7.29445 8.53331 6.99981 8.53331H4.99981C4.70516 8.53331 4.46631 8.29445 4.46631 7.99981ZM8.46631 7.99981C8.46631 7.70516 8.70516 7.46631 8.99981 7.46631H10.9998C11.2945 7.46631 11.5333 7.70516 11.5333 7.99981C11.5333 8.29445 11.2945 8.53331 10.9998 8.53331H8.99981C8.70516 8.53331 8.46631 8.29445 8.46631 7.99981ZM12.4663 7.99981C12.4663 7.70516 12.7052 7.46631 12.9998 7.46631H14.9998C15.2945 7.46631 15.5333 7.70516 15.5333 7.99981C15.5333 8.29445 15.2945 8.53331 14.9998 8.53331H12.9998C12.7052 8.53331 12.4663 8.29445 12.4663 7.99981ZM2.8792 9.48224C3.16505 9.5537 3.33884 9.84335 3.26738 10.1292L2.01738 15.1292C1.94592 15.415 1.65626 15.5888 1.37042 15.5174C1.08457 15.4459 0.910776 15.1563 0.982238 14.8704L2.23224 9.87042C2.3037 9.58457 2.59335 9.41078 2.8792 9.48224ZM12.9998 10.4663C13.2945 10.4663 13.5333 10.7052 13.5333 10.9998V12.4663H14.9998C15.2945 12.4663 15.5333 12.7052 15.5333 12.9998C15.5333 13.2945 15.2945 13.5333 14.9998 13.5333H13.5333V14.9998C13.5333 15.2945 13.2945 15.5333 12.9998 15.5333C12.7052 15.5333 12.4663 15.2945 12.4663 14.9998V13.5333H10.9998C10.7052 13.5333 10.4663 13.2945 10.4663 12.9998C10.4663 12.7052 10.7052 12.4663 10.9998 12.4663H12.4663V10.9998C12.4663 10.7052 12.7052 10.4663 12.9998 10.4663Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.ColumnCompress: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.53349 1.60004C8.53349 1.3055 8.29471 1.06671 8.00016 1.06671C7.70561 1.06671 7.46683 1.3055 7.46683 1.60004V14.4C7.46683 14.6945 7.70561 14.9334 8.00016 14.9334C8.29471 14.9334 8.53349 14.6945 8.53349 14.4V1.60004ZM12.8123 6.20588C12.9997 6.01843 12.9997 5.71451 12.8123 5.52706C12.6248 5.33961 12.3209 5.33961 12.1335 5.52706L10.0001 7.6604C9.81267 7.84784 9.81267 8.15177 10.0001 8.33921L12.1335 10.4725C12.3209 10.66 12.6248 10.66 12.8123 10.4725C12.9997 10.2851 12.9997 9.98118 12.8123 9.79373L11.4984 8.4798H15.1398C15.4049 8.4798 15.6198 8.2649 15.6198 7.9998C15.6198 7.73471 15.4049 7.5198 15.1398 7.5198H11.4984L12.8123 6.20588ZM3.86482 5.52707C3.67741 5.33961 3.37351 5.33961 3.18599 5.52707C2.99858 5.71451 2.99858 6.01844 3.18599 6.20588L4.49991 7.5198H0.859028C0.593929 7.5198 0.379028 7.73471 0.379028 7.9998C0.379028 8.2649 0.593929 8.4798 0.859028 8.4798H4.49991L3.18599 9.79373C2.99858 9.98118 2.99858 10.2851 3.18599 10.4725C3.37351 10.66 3.67741 10.66 3.86482 10.4725L5.99815 8.33921C6.18567 8.15177 6.18567 7.84784 5.99815 7.6604L3.86482 5.52707Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case CustomIconPath.ColumnStretch: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.53342 1.59998C8.53342 1.30543 8.29464 1.06665 8.00009 1.06665C7.70554 1.06665 7.46675 1.30543 7.46675 1.59998V14.4C7.46675 14.6945 7.70554 14.9333 8.00009 14.9333C8.29464 14.9333 8.53342 14.6945 8.53342 14.4V1.59998ZM3.53929 6.20585C3.72674 6.01841 3.72674 5.71448 3.53929 5.52703C3.35184 5.33958 3.04792 5.33958 2.86047 5.52703L0.727137 7.66037C0.539685 7.84781 0.539685 8.15174 0.727137 8.33918L2.86047 10.4725C3.04792 10.66 3.35184 10.66 3.53929 10.4725C3.72674 10.2851 3.72674 9.98115 3.53929 9.7937L2.22537 8.47977H5.86681C6.13191 8.47977 6.34681 8.26487 6.34681 7.99977C6.34681 7.73468 6.13191 7.51977 5.86681 7.51977H2.22537L3.53929 6.20585ZM13.1393 5.52703C12.9519 5.33958 12.648 5.33958 12.4604 5.52703C12.273 5.71448 12.273 6.01841 12.4604 6.20585L13.7744 7.51977H10.1335C9.86838 7.51977 9.65347 7.73468 9.65347 7.99977C9.65347 8.26487 9.86838 8.47977 10.1335 8.47977H13.7744L12.4604 9.7937C12.273 9.98115 12.273 10.2851 12.4604 10.4725C12.648 10.66 12.9519 10.66 13.1393 10.4725L15.2726 8.33918C15.4601 8.15174 15.4601 7.84781 15.2726 7.66037L13.1393 5.52703Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case CustomIconPath.RowCompress: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.59998 7.46657C1.30543 7.46657 1.06665 7.70535 1.06665 7.9999C1.06665 8.29445 1.30543 8.53323 1.59998 8.53323L14.4 8.53323C14.6945 8.53323 14.9333 8.29445 14.9333 7.9999C14.9333 7.70535 14.6945 7.46657 14.4 7.46657L1.59998 7.46657ZM6.20582 3.18779C6.01837 3.00033 5.71445 3.00033 5.527 3.18779C5.33955 3.37523 5.33955 3.67916 5.527 3.8666L7.66034 5.99994C7.84778 6.18739 8.15171 6.18739 8.33915 5.99994L10.4725 3.8666C10.6599 3.67916 10.6599 3.37523 10.4725 3.18779C10.285 3.00033 9.98111 3.00033 9.79367 3.18779L8.47974 4.50171L8.47974 0.860268C8.47974 0.59517 8.26484 0.380269 7.99974 0.380269C7.73465 0.380269 7.51974 0.59517 7.51974 0.860268L7.51974 4.50171L6.20582 3.18779ZM5.52701 12.1352C5.33955 12.3227 5.33955 12.6265 5.52701 12.8141C5.71445 13.0015 6.01838 13.0015 6.20582 12.8141L7.51974 11.5001L7.51974 15.141C7.51974 15.4061 7.73465 15.621 7.99974 15.621C8.26484 15.621 8.47974 15.4061 8.47974 15.141L8.47974 11.5001L9.79367 12.8141C9.98111 13.0015 10.285 13.0015 10.4725 12.8141C10.6599 12.6265 10.6599 12.3227 10.4725 12.1352L8.33915 10.0019C8.15171 9.81439 7.84778 9.81439 7.66034 10.0019L5.52701 12.1352Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case CustomIconPath.RowStretch: {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4 8.53348C14.6946 8.53348 14.9333 8.2947 14.9333 8.00015C14.9333 7.7056 14.6946 7.46682 14.4 7.46682L1.60002 7.46681C1.30551 7.46681 1.06668 7.7056 1.06668 8.00015C1.06668 8.2947 1.30551 8.53348 1.60002 8.53348L14.4 8.53348ZM9.79415 3.53935C9.98159 3.7268 10.2855 3.7268 10.473 3.53935C10.6604 3.3519 10.6604 3.04798 10.473 2.86053L8.33963 0.727197C8.15219 0.539746 7.84826 0.539746 7.66082 0.727197L5.52748 2.86053C5.34003 3.04798 5.34003 3.3519 5.52748 3.53935C5.71493 3.7268 6.01885 3.7268 6.2063 3.53935L7.52023 2.22543L7.52023 5.86687C7.52023 6.13197 7.73513 6.34687 8.00023 6.34687C8.26532 6.34687 8.48023 6.13197 8.48023 5.86687L8.48023 2.22543L9.79415 3.53935ZM10.473 13.1393C10.6604 12.9519 10.6604 12.648 10.473 12.4605C10.2855 12.2731 9.98159 12.2731 9.79415 12.4605L8.48023 13.7744L8.48023 10.1335C8.48023 9.86844 8.26532 9.65354 8.00023 9.65354C7.73513 9.65354 7.52023 9.86844 7.52023 10.1335L7.52023 13.7744L6.2063 12.4605C6.01885 12.2731 5.71493 12.2731 5.52748 12.4605C5.34003 12.648 5.34003 12.9519 5.52748 13.1393L7.66082 15.2727C7.84826 15.4602 8.15219 15.4602 8.33963 15.2727L10.473 13.1393Z"
            fill="currentColor"
          />
        </svg>
      );
    }

    case CustomIconPath.Spinner: {
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1345_80521)">
            <rect width="12" height="12" fill="white" fillOpacity="0.01" />
            <g clipPath="url(#clip1_1345_80521)">
              <g clipPath="url(#clip2_1345_80521)">
                <path
                  d="M5.25 0.75C5.25 0.335786 5.58579 0 6 0C6.41421 0 6.75 0.335786 6.75 0.75V3.25C6.75 3.66421 6.41421 4 6 4C5.58579 4 5.25 3.66421 5.25 3.25V0.75Z"
                  fill="#F1F7FE"
                  fillOpacity="0.709804"
                />
              </g>
              <g clipPath="url(#clip3_1345_80521)">
                <path
                  d="M9.18207 1.75738C9.47497 1.46449 9.94984 1.46449 10.2427 1.75738C10.5356 2.05027 10.5356 2.52515 10.2427 2.81804L8.47497 4.58581C8.18207 4.8787 7.7072 4.8787 7.41431 4.58581C7.12141 4.29291 7.12141 3.81804 7.41431 3.52515L9.18207 1.75738Z"
                  fill="#E5EDFD"
                  fillOpacity="0.482353"
                />
              </g>
              <g clipPath="url(#clip4_1345_80521)">
                <path
                  d="M11.25 5.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75L8.75 6.75C8.33579 6.75 8 6.41421 8 6C8 5.58579 8.33579 5.25 8.75 5.25L11.25 5.25Z"
                  fill="#DFEBFD"
                  fillOpacity="0.427451"
                />
              </g>
              <g clipPath="url(#clip5_1345_80521)">
                <path
                  d="M10.2426 9.18195C10.5355 9.47484 10.5355 9.94972 10.2426 10.2426C9.94973 10.5355 9.47485 10.5355 9.18196 10.2426L7.41419 8.47484C7.1213 8.18195 7.1213 7.70708 7.41419 7.41418C7.70709 7.12129 8.18196 7.12129 8.47485 7.41418L10.2426 9.18195Z"
                  fill="#D9EDFF"
                  fillOpacity="0.364706"
                />
              </g>
              <g clipPath="url(#clip6_1345_80521)">
                <path
                  d="M6.75 11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25L5.25 8.75C5.25 8.33579 5.58579 8 6 8C6.41421 8 6.75 8.33579 6.75 8.75L6.75 11.25Z"
                  fill="#D9EDFF"
                  fillOpacity="0.25098"
                />
              </g>
              <g clipPath="url(#clip7_1345_80521)">
                <path
                  d="M2.81793 10.2426C2.52503 10.5355 2.05016 10.5355 1.75727 10.2426C1.46437 9.94973 1.46437 9.47485 1.75727 9.18196L3.52503 7.41419C3.81793 7.1213 4.2928 7.1213 4.58569 7.41419C4.87859 7.70709 4.87859 8.18196 4.58569 8.47485L2.81793 10.2426Z"
                  fill="#D6EBFD"
                  fillOpacity="0.188235"
                />
              </g>
              <g clipPath="url(#clip8_1345_80521)">
                <path
                  d="M0.75 6.75C0.335786 6.75 4.66981e-08 6.41421 1.04303e-07 6C1.61908e-07 5.58579 0.335787 5.25 0.75 5.25L3.25 5.25C3.66421 5.25 4 5.58579 4 6C4 6.41421 3.66421 6.75 3.25 6.75L0.75 6.75Z"
                  fill="#D9EDFE"
                  fillOpacity="0.145098"
                />
              </g>
              <g clipPath="url(#clip9_1345_80521)">
                <path
                  d="M1.75738 2.81805C1.46449 2.52516 1.46449 2.05028 1.75738 1.75739C2.05027 1.4645 2.52515 1.4645 2.81804 1.75739L4.58581 3.52516C4.8787 3.81805 4.8787 4.29292 4.58581 4.58582C4.29291 4.87871 3.81804 4.87871 3.52515 4.58582L1.75738 2.81805Z"
                  fill="#D3EDF8"
                  fillOpacity="0.113725"
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1345_80521">
              <rect width="12" height="12" fill="white" />
            </clipPath>
            <clipPath id="clip1_1345_80521">
              <rect width="12" height="12" fill="white" />
            </clipPath>
            <clipPath id="clip2_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(5.25)"
              />
            </clipPath>
            <clipPath id="clip3_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(9.7124 1.22705) rotate(45)"
              />
            </clipPath>
            <clipPath id="clip4_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(12 5.25) rotate(90)"
              />
            </clipPath>
            <clipPath id="clip5_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(10.7729 9.71228) rotate(135)"
              />
            </clipPath>
            <clipPath id="clip6_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(6.75 12) rotate(-180)"
              />
            </clipPath>
            <clipPath id="clip7_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(2.2876 10.7729) rotate(-135)"
              />
            </clipPath>
            <clipPath id="clip8_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(0 6.75) rotate(-90)"
              />
            </clipPath>
            <clipPath id="clip9_1345_80521">
              <rect
                width="1.5"
                height="12"
                fill="white"
                transform="translate(1.22705 2.28772) rotate(-45)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    }

    case CustomIconPath.FilledCircle: {
      return (
        <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg">
          <circle r="6" cx="8" cy="10" fill="currentColor" />
        </svg>
      );
    }

    default: {
      return <QuestionMarkIcon />;
    }
  }
};

export const CustomIcon = (props: {
  icon: CustomIconPath;
  className?: string;
  color?: RadixColor;
  title?: string;
}) => {
  const content = useMemo(() => getContent(props.icon), [props.icon]);
  const className = StringHelper.classNames(['CustomIcon', props.className]);

  return (
    <Text className={className} title={props.title} color={props.color} asChild>
      {content}
    </Text>
  );
};
